import React from 'react';
import ContentLoader from 'react-content-loader';
import PanelContainer from 'components/PanelContainer';

const FirmOverviewContentLoader = props => (
  <PanelContainer
    styles={{
      height: '370px',
      padding: '30px',
    }}
  >
    <ContentLoader
      height={370}
      width={825}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="303" y="99" rx="3" ry="3" width="201" height="20" />
      <rect x="303" y="63" rx="3" ry="3" width="201" height="20" />
      <rect x="0" y="63" rx="3" ry="3" width="189" height="20" />
      <rect x="0" y="99" rx="3" ry="3" width="189" height="20" />
      <rect x="0" y="20" rx="3" ry="3" width="122" height="20" />
      <rect x="606" y="63" rx="3" ry="3" width="201" height="20" />
      <rect x="606" y="99" rx="3" ry="3" width="90" height="20" />
      <rect x="0" y="158" rx="3" ry="3" width="189" height="20" />
      <rect x="0" y="197" rx="3" ry="3" width="189" height="20" />
      <rect x="303" y="158" rx="3" ry="3" width="201" height="20" />
      <rect x="303" y="197" rx="3" ry="3" width="201" height="20" />
      <rect x="606" y="158" rx="3" ry="3" width="201" height="20" />
      <rect x="606" y="197" rx="3" ry="3" width="90" height="20" />
      <rect x="0" y="263" rx="3" ry="3" width="809" height="20" />
      <rect x="0" y="298" rx="3" ry="3" width="809" height="20" />
    </ContentLoader>
  </PanelContainer>
);

export default FirmOverviewContentLoader;
